// extracted by mini-css-extract-plugin
module.exports = {"cardInput":"UpdateCardModal_cardInput__oGD5a","cardSub":"UpdateCardModal_cardSub__3tmTq"};